<template>
  <main class="clienteHome">
    <header class="clienteHomeCabecalho">
      <div class="clienteHomeIdentidade">
        <router-link to="/" title="Weddbets">
          <img
            class="clienteHomeLogo"
            src="/assets/logoc.png"
            alt="Weddbets"
          />
        </router-link>
        <p v-if="erro || !atualizadoEm" class="clienteHomeAtualizacao">
          <span :class="{ erro: !!erro }"></span>
          {{ erro ? erro : "Carregando programação" }}
        </p>
      </div>

      <div class="clienteHomeFerramentas">
        <label class="clienteHomeBusca">
          <i class="fa fa-search" aria-hidden="true"></i>
          <input
            v-model.trim="busca"
            type="search"
            placeholder="Buscar evento ou competição"
            aria-label="Buscar evento ou competição"
          />
        </label>
        <label class="clienteHomeOrdenacao" title="Ordenar eventos">
          <i class="fa fa-sort-amount-asc" aria-hidden="true"></i>
          <select
            v-model="ordenacao"
            aria-label="Ordenar eventos"
            @change="salvarOrdenacao"
          >
            <option value="competicao">Competição</option>
            <option value="horario">Horário</option>
          </select>
        </label>
        <button
          type="button"
          class="clienteHomeAtualizar"
          :disabled="carregando"
          title="Atualizar"
          aria-label="Atualizar programação"
          @click="carregarDados"
        >
          <i
            class="fa fa-refresh"
            :class="{ girando: carregando }"
            aria-hidden="true"
          ></i>
        </button>
      </div>
    </header>

    <nav class="clienteHomeAbas" aria-label="Situação dos eventos">
      <button
        v-for="aba in abas"
        :key="aba.id"
        type="button"
        :class="{ ativo: abaSelecionada == aba.id }"
        @click="abaSelecionada = aba.id"
      >
        <i :class="'fa ' + aba.icone" aria-hidden="true"></i>
        {{ aba.nome }} ({{ contagensAbas[aba.id] || 0 }})
      </button>
    </nav>

    <div class="clienteHomeAtalhos">
      <multi-evento-button />
      <button
        type="button"
        class="clienteCompeticoesAbrir"
        @click="dialogCompeticoesAberta = true"
      >
        <i class="fa fa-filter" aria-hidden="true"></i>
        <span>Competições</span>
        <small>
          {{ competicoesSelecionadas.length }}/{{ competicoesDisponiveis.length }}
        </small>
      </button>

      <button
        v-if="competicoesRecolhidas"
        type="button"
        class="clienteCompeticoesReabrir"
        @click="alternarColunaCompeticoes"
      >
        <i class="fa fa-filter" aria-hidden="true"></i>
        <span>Mostrar competições</span>
        <small>
          {{ competicoesSelecionadas.length }}/{{ competicoesDisponiveis.length }}
        </small>
      </button>
    </div>

    <section
      class="clienteHomeConteudo"
      :class="{
        clienteHomeConteudoSemCompeticoes: competicoesRecolhidas,
      }"
    >
      <div class="clienteHomeLista">
        <div v-if="carregando && !itens.length" class="clienteHomeEstado">
          <i class="fa fa-refresh girando" aria-hidden="true"></i>
          <strong>Carregando programação</strong>
        </div>

        <div v-else-if="!grupos.length" class="clienteHomeEstado">
          <i class="fa fa-calendar-times-o" aria-hidden="true"></i>
          <strong>Nenhum evento encontrado</strong>
          <span v-if="!competicoesSelecionadas.length">
            Selecione ao menos uma competição.
          </span>
          <span v-else>Altere a busca ou consulte outra situação.</span>
        </div>

        <section
          v-for="grupo in grupos"
          :key="grupo.chave"
          class="clienteCompeticao"
        >
          <header>
            <i
              v-if="grupo.tipo == 'horario'"
              class="fa fa-clock-o"
              aria-hidden="true"
            ></i>
            <img
              v-else
              :src="grupo.bandeira"
              alt=""
              @error="usarBandeiraPadrao"
            />
            <div>
              <strong>{{ grupo.nome }}</strong>
            </div>
          </header>

          <article
            v-for="item in grupo.itens"
            :key="item._id"
            class="clienteEvento"
            :class="{ clienteEventoAoVivo: item.situacao == 3 }"
          >
            <time>
              <strong>{{ formatarHoraEvento(item) }}</strong>
              <span v-if="item.situacao == 3">AO VIVO</span>
              <small v-else>{{ nomeSituacao(item.situacao) }}</small>
            </time>

            <button
              type="button"
              class="clienteEventoNome"
              :disabled="!podeAbrir(item)"
              @click="abrirEvento(item)"
            >
              <span>{{ item.nome || "Evento sem nome" }}</span>
            </button>

            <button
              type="button"
              class="clienteEventoFavorito"
              :class="{ ativo: !!itensFavoritos[item._id] }"
              :title="
                itensFavoritos[item._id]
                  ? 'Remover dos favoritos'
                  : 'Adicionar aos favoritos'
              "
              :aria-label="
                itensFavoritos[item._id]
                  ? 'Remover dos favoritos'
                  : 'Adicionar aos favoritos'
              "
              @click="alternarFavorito(item)"
            >
              <i
                class="fa"
                :class="
                  itensFavoritos[item._id] ? 'fa-star' : 'fa-star-o'
                "
                aria-hidden="true"
              ></i>
            </button>

            <button
              type="button"
              class="clienteEventoAssistir clienteEventoAssistirGrafico"
              :disabled="!podeAbrir(item)"
              :title="
                podeAbrir(item)
                  ? 'Assistir com gráfico'
                  : 'Transmissão ainda não disponível'
              "
              :aria-label="
                podeAbrir(item)
                  ? 'Assistir com gráfico'
                  : 'Transmissão ainda não disponível'
              "
              @click="abrirEvento(item, false)"
            >
              <i class="fa fa-bar-chart" aria-hidden="true"></i>
            </button>

            <button
              type="button"
              class="clienteEventoAssistir clienteEventoAssistirLimpo"
              :disabled="!podeAbrir(item)"
              :title="
                podeAbrir(item)
                  ? 'Assistir sem gráfico'
                  : 'Transmissão ainda não disponível'
              "
              :aria-label="
                podeAbrir(item)
                  ? 'Assistir sem gráfico'
                  : 'Transmissão ainda não disponível'
              "
              @click="abrirEvento(item, true)"
            >
              <i class="fa fa-television" aria-hidden="true"></i>
            </button>
          </article>
        </section>
      </div>

      <aside class="clienteHomeLateral">
        <section class="clienteLateralBloco">
          <header>
            <span>Minha assinatura</span>
            <strong :class="{ inativo: !planoAtivo }">
              {{ planoAtivo ? "Ativa" : "Inativa" }}
            </strong>
          </header>
          <div class="clientePlanoDetalhe">
            <i class="fa fa-shield" aria-hidden="true"></i>
            <div>
              <strong v-if="planoAtivo && vencimento">
                Válida até {{ vencimento }}
              </strong>
              <strong v-else-if="planoAtivo">Acesso liberado</strong>
              <strong v-else>Sem plano ativo</strong>
              <span v-if="planosAgendados.length">
                {{ planosAgendados.length }} renovações agendadas
              </span>
              <span v-else>Consulte aqui a situação do seu acesso.</span>
            </div>
          </div>
          <router-link
            v-if="podeVerMeusDados"
            to="/meus-dados"
            class="clienteContaLink"
          >
            Gerenciar minha conta
            <i class="fa fa-angle-right" aria-hidden="true"></i>
          </router-link>
        </section>

        <div
          class="clienteCompeticoesDialog"
          :class="{ ativo: dialogCompeticoesAberta }"
          :role="dialogCompeticoesAberta ? 'dialog' : null"
          :aria-modal="dialogCompeticoesAberta ? 'true' : null"
          aria-label="Selecionar competições"
          @click.self="dialogCompeticoesAberta = false"
        >
          <section class="clienteLateralBloco clienteFiltroCompeticoes">
          <header>
            <div>
              <span>Competições</span>
              <small>
                {{ competicoesSelecionadas.length }} de
                {{ competicoesDisponiveis.length }} selecionadas
              </small>
            </div>
            <button
              type="button"
              :disabled="!competicoesDisponiveis.length"
              @click="alternarTodasCompeticoes"
            >
              {{ todasCompeticoesSelecionadas ? "Limpar" : "Todas" }}
            </button>
            <button
              type="button"
              class="clienteCompeticoesRecolher"
              title="Recolher competições"
              aria-label="Recolher competições"
              @click="alternarColunaCompeticoes"
            >
              <i class="fa fa-angle-right" aria-hidden="true"></i>
            </button>
            <button
              type="button"
              class="clienteCompeticoesFechar"
              title="Fechar"
              aria-label="Fechar competições"
              @click="dialogCompeticoesAberta = false"
            >
              <i class="fa fa-times" aria-hidden="true"></i>
            </button>
          </header>
          <div
            v-if="competicoesDisponiveis.length"
            class="clienteCompeticoesOpcoes"
            role="group"
            aria-label="Filtrar por competições"
          >
            <div class="clienteCompeticoesBusca">
              <i class="fa fa-search" aria-hidden="true"></i>
              <input
                v-model.trim="filtroCompeticao"
                type="search"
                placeholder="Buscar competição"
                aria-label="Buscar competição"
              />
              <button
                v-if="filtroCompeticao"
                type="button"
                title="Limpar busca"
                aria-label="Limpar busca de competição"
                @click="filtroCompeticao = ''"
              >
                <i class="fa fa-times" aria-hidden="true"></i>
              </button>
            </div>
            <label
              v-for="competicao in competicoesVisiveis"
              :key="competicao.nome"
              class="clienteCompeticaoOpcao"
              :class="{
                ativo: competicoesSelecionadas.includes(competicao.nome),
              }"
            >
              <input
                v-model="competicoesSelecionadas"
                type="checkbox"
                :value="competicao.nome"
              />
              <img
                :src="competicao.bandeira"
                alt=""
                @error="usarBandeiraPadrao"
              />
              <span>{{ competicao.nome }}</span>
              <small>{{ competicao.quantidade }}</small>
            </label>
            <div
              v-if="!competicoesVisiveis.length"
              class="clienteCompeticoesVazio"
            >
              Nenhuma competição encontrada
            </div>
          </div>
          <div v-else class="clienteCompeticoesVazio">
            Nenhuma competição disponível
          </div>
          <footer>
            <span>{{ itensFiltrados.length }} eventos exibidos</span>
            <span>{{ formatarGmt(gmtUsuario) }}</span>
          </footer>
          </section>
        </div>
      </aside>
    </section>
  </main>
</template>

<script>
import { api } from "@/services/api.js";
import util from "@/includes/util.js";
import MultiEventoButton from "@/components/MultiEventoButton.vue";

function carregarOrdenacaoInicial() {
  try {
    var ordenacao = localStorage.getItem("clienteOrdenacao");
    return ordenacao == "horario" ? "horario" : "competicao";
  } catch (erro) {
    return "competicao";
  }
}

function carregarCompeticoesRecolhidas() {
  try {
    return localStorage.getItem("clienteCompeticoesRecolhidas") == "true";
  } catch (erro) {
    return false;
  }
}

export default {
  name: "ClienteHome",
  components: { MultiEventoButton },
  props: {
    propFavorito: { type: Boolean, default: false },
  },
  data() {
    return {
      abaSelecionada: this.propFavorito ? "todos" : "ao-vivo",
      atualizadoEm: null,
      busca: "",
      carregando: false,
      competicoesRecolhidas: carregarCompeticoesRecolhidas(),
      competicoesSelecionadas: [],
      dialogCompeticoesAberta: false,
      erro: "",
      filtroCompeticao: "",
      filtroCompeticoesInicializado: false,
      gmtUsuario: -3,
      intervalo: null,
      itens: [],
      itensFavoritos: {},
      ordenacao: carregarOrdenacaoInicial(),
      planoAtivo: true,
      planoDias: 0,
      planosAgendados: [],
      vencimento: "",
      abas: [
        { id: "ao-vivo", nome: "Ao vivo", icone: "fa-play-circle" },
        { id: "previstos", nome: "Previstos", icone: "fa-calendar-o" },
        { id: "encerrados", nome: "Encerrados", icone: "fa-check-circle-o" },
      ],
    };
  },
  computed: {
    usuario() {
      return this.$sessao && this.$sessao.usuario
        ? this.$sessao.usuario
        : {};
    },
    tipoUsuario() {
      return this.usuario.tipoUsuario || "";
    },
    podeVerMeusDados() {
      return this.tipoUsuario
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "") !== "Degustacao";
    },
    competicoesDisponiveis() {
      var competicoes = {};

      this.itens.forEach((item) => {
        var nome = this.nomeCompeticao(item);

        if (!competicoes[nome]) {
          competicoes[nome] = {
            nome: nome,
            bandeira: item.competicaoPaisUrl || "/assets/worldflag3.png",
            quantidade: 0,
          };
        }

        competicoes[nome].quantidade += 1;
      });

      return Object.values(competicoes).sort((a, b) =>
        a.nome.localeCompare(b.nome, "pt-BR")
      );
    },
    competicoesVisiveis() {
      var termo = this.normalizarTexto(this.filtroCompeticao);

      if (!termo) {
        return this.competicoesDisponiveis;
      }

      return this.competicoesDisponiveis.filter((competicao) =>
        this.normalizarTexto(competicao.nome).includes(termo)
      );
    },
    todasCompeticoesSelecionadas() {
      return (
        this.competicoesDisponiveis.length > 0 &&
        this.competicoesDisponiveis.every((competicao) =>
          this.competicoesSelecionadas.includes(competicao.nome)
        )
      );
    },
    itensBaseFiltrados() {
      var termo = this.normalizarTexto(this.busca);

      return this.itens.filter((item) => {
        if (!this.competicoesSelecionadas.includes(this.nomeCompeticao(item))) {
          return false;
        }

        if (this.propFavorito && !this.itensFavoritos[item._id]) {
          return false;
        }

        if (!termo) {
          return true;
        }

        return (
          this.normalizarTexto(item.nome).includes(termo) ||
          this.normalizarTexto(item.competicao).includes(termo)
        );
      });
    },
    contagensAbas() {
      return {
        "ao-vivo": this.itensBaseFiltrados.filter(
          (item) => item.situacao == 3
        ).length,
        previstos: this.itensBaseFiltrados.filter(
          (item) => item.situacao == 1
        ).length,
        encerrados: this.itensBaseFiltrados.filter(
          (item) => item.situacao == 4
        ).length,
      };
    },
    itensFiltrados() {
      var situacoes = {
        "ao-vivo": [3],
        previstos: [1],
        encerrados: [4],
        todos: [1, 2, 3, 4],
      };

      return this.itensBaseFiltrados.filter((item) =>
        situacoes[this.abaSelecionada].includes(item.situacao)
      );
    },
    grupos() {
      var itensOrdenados = this.itensFiltrados
        .slice()
        .sort(this.compararHorario);

      if (this.ordenacao == "horario") {
        return itensOrdenados.reduce((grupos, item) => {
          var nome = this.nomeCompeticao(item);
          var ultimoGrupo = grupos[grupos.length - 1];

          if (!ultimoGrupo || ultimoGrupo.nome != nome) {
            ultimoGrupo = {
              chave: "horario-" + grupos.length + "-" + nome,
              nome: nome,
              tipo: "competicao",
              bandeira: item.competicaoPaisUrl || "/assets/worldflag3.png",
              itens: [],
            };
            grupos.push(ultimoGrupo);
          }

          ultimoGrupo.itens.push(item);
          return grupos;
        }, []);
      }

      var grupos = {};

      itensOrdenados.forEach((item) => {
        var nome = item.competicao || "Sem competição";

        if (!grupos[nome]) {
          grupos[nome] = {
            chave: "competicao-" + nome,
            nome: nome,
            tipo: "competicao",
            bandeira: item.competicaoPaisUrl || "/assets/worldflag3.png",
            itens: [],
          };
        }

        grupos[nome].itens.push(item);
      });

      return Object.values(grupos).sort((a, b) =>
        a.nome.localeCompare(b.nome, "pt-BR")
      );
    },
  },
  watch: {
    propFavorito(novoValor) {
      this.abaSelecionada = novoValor ? "todos" : "ao-vivo";
    },
  },
  methods: {
    normalizarTexto(valor) {
      return (valor || "")
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLocaleLowerCase("pt-BR");
    },
    nomeCompeticao(item) {
      return item.competicao || "Sem competição";
    },
    alternarTodasCompeticoes() {
      this.competicoesSelecionadas = this.todasCompeticoesSelecionadas
        ? []
        : this.competicoesDisponiveis.map((competicao) => competicao.nome);
    },
    alternarColunaCompeticoes() {
      this.competicoesRecolhidas = !this.competicoesRecolhidas;
      try {
        localStorage.setItem(
          "clienteCompeticoesRecolhidas",
          this.competicoesRecolhidas
        );
      } catch (erro) {
        return;
      }
    },
    sincronizarCompeticoes(eventos) {
      var selecionarTodas =
        !this.filtroCompeticoesInicializado ||
        this.todasCompeticoesSelecionadas;
      var nomes = Array.from(
        new Set(eventos.map((item) => this.nomeCompeticao(item)))
      );

      this.competicoesSelecionadas = selecionarTodas
        ? nomes
        : this.competicoesSelecionadas.filter((nome) => nomes.includes(nome));
      this.filtroCompeticoesInicializado = true;
    },
    compararHorario(a, b) {
      return (
        this.minutosEvento(a) - this.minutosEvento(b) ||
        (a.nome || "").localeCompare(b.nome || "", "pt-BR")
      );
    },
    minutosEvento(item) {
      var hora = Number(item.dataHora);
      var minuto = Number(item.dataMinuto);

      if (Number.isNaN(hora) || Number.isNaN(minuto)) {
        return Number.MAX_SAFE_INTEGER;
      }

      hora = (hora + 3 + Number(this.gmtUsuario) + 24) % 24;
      return hora * 60 + minuto;
    },
    salvarOrdenacao() {
      try {
        localStorage.setItem("clienteOrdenacao", this.ordenacao);
      } catch (erro) {
        return;
      }
    },
    async carregarDados() {
      if (this.carregando) return;

      this.carregando = true;
      this.erro = "";

      try {
        await Promise.all([
          this.carregarEventos(),
          this.carregarFavoritos(),
          this.carregarPlano(),
        ]);
        this.atualizadoEm = new Date();
      } catch (erro) {
        this.erro = "Não foi possível atualizar a programação";
      } finally {
        this.carregando = false;
      }
    },
    async carregarEventos() {
      var rota = this.tipoUsuario == "Assinante" ? "/evento/cache" : "/evento";
      var response = await api.get(rota + "?_limit=600");

      api.valid(response.data, this.$router);

      var eventos = response.data.itens || [];
      var eventosFormatados = eventos
        .filter((item) => item.site !== "Extra")
        .map((item) => {
          var pais = "";

          if (item.competicao) {
            var codigoPais = util.countryNameToCode(
              item.competicao.split(",")[0]
            );
            pais = codigoPais ? codigoPais.toLowerCase() : "";
          }

          return Object.assign({}, item, {
            competicaoPaisUrl: pais
              ? "https://flagcdn.com/h20/" + pais + ".png"
              : "/assets/worldflag3.png",
          });
        });

      this.sincronizarCompeticoes(eventosFormatados);
      this.itens = eventosFormatados;
    },
    async carregarFavoritos() {
      var response = await api.get("/favorito");
      var favoritos = {};

      if (!response.data.erro) {
        (response.data.itens || []).forEach((item) => {
          favoritos[item.evento] = item;
        });
      }

      this.itensFavoritos = favoritos;
    },
    async carregarPlano() {
      var response = await api.get("/usuario/meus-dados");
      var item = response.data.item || {};

      this.planoAtivo = item.planoAtivo;
      this.planoDias = Number(item.planoDias || 0);
      this.planosAgendados = item.planosAgendados || [];

      if (item.plano && item.plano.dataFim) {
        this.vencimento = util.formatDate(item.plano.dataFim);
      } else if (item.vencimento) {
        this.vencimento = util.formatDate(item.vencimento);
      } else {
        this.vencimento = "";
      }
    },
    alternarFavorito(item) {
      if (this.itensFavoritos[item._id]) {
        this.$delete(this.itensFavoritos, item._id);
        api.put("/favorito", { evento: item._id });
      } else {
        this.$set(this.itensFavoritos, item._id, true);
        api.post("/favorito", { evento: item._id });
      }
    },
    podeAbrir(item) {
      return (
        item.situacao == 3 ||
        this.tipoUsuario == "Administrador" ||
        this.tipoUsuario == "Apresentador"
      );
    },
    abrirEvento(item, limpo) {
      if (!this.podeAbrir(item)) return;

      var url = "/view/" + item._id;

      if (limpo) {
        url += "?view=clean";
      }

      window.open(
        url,
        "evento_" + Date.now(),
        "scrollbars=1,width=450,height=" + (limpo ? "500" : "690")
      );
    },
    formatarHoraEvento(item) {
      var hora = Number(item.dataHora);
      var minuto = Number(item.dataMinuto);

      if (Number.isNaN(hora) || Number.isNaN(minuto)) return "--:--";

      var data = new Date();
      data.setHours(hora + 3 + Number(this.gmtUsuario), minuto, 0, 0);

      return (
        String(data.getHours()).padStart(2, "0") +
        ":" +
        String(data.getMinutes()).padStart(2, "0")
      );
    },
    formatarGmt(gmt) {
      var valor = Number(gmt);
      return "GMT " + (valor >= 0 ? "+" : "") + valor;
    },
    nomeSituacao(situacao) {
      if (situacao == 1) return "Previsto";
      if (situacao == 4) return "Encerrado";
      if (situacao == 2) return "Indisponível";
      return "";
    },
    usarBandeiraPadrao(evento) {
      evento.target.src = "/assets/worldflag3.png";
    },
  },
  mounted() {
    if (this.usuario.gmt !== undefined && this.usuario.gmt !== null) {
      this.gmtUsuario = Number(this.usuario.gmt);
    }

    this.carregarDados();
    this.intervalo = setInterval(this.carregarDados, 20000);
  },
  beforeDestroy() {
    if (this.intervalo) clearInterval(this.intervalo);
  },
};
</script>

<style scoped>
.clienteHome {
  color: #283036;
  margin: 0 auto;
  max-width: 1440px;
  min-height: calc(100vh - 64px);
  padding: 24px 28px 48px;
  text-align: left;
}

.clienteHomeCabecalho {
  align-items: flex-end;
  border-bottom: 1px solid #dce1e4;
  display: flex;
  justify-content: space-between;
  padding-bottom: 18px;
}

.clienteHomeIdentidade {
  align-items: flex-start;
  display: flex;
  flex-direction: column;
}

.clienteHomeIdentidade > a {
  display: inline-flex;
}

.clienteHomeLogo {
  display: block;
  height: 38px;
  max-width: 100%;
  object-fit: contain;
  width: auto;
}

.clienteHomeAtualizacao {
  align-items: center;
  color: #788188;
  display: flex;
  font-size: 10px;
  gap: 6px;
  margin: 5px 0 0;
}

.clienteHomeAtualizacao > span {
  background: #35a66f;
  border-radius: 50%;
  height: 7px;
  width: 7px;
}

.clienteHomeAtualizacao > span.erro {
  background: #c45454;
}

.clienteHomeFerramentas {
  align-items: center;
  display: flex;
  gap: 8px;
}

.clienteHomeBusca {
  align-items: center;
  background: #ffffff;
  border: 1px solid #cfd5d9;
  display: flex;
  height: 38px;
  margin: 0;
  min-width: 300px;
}

.clienteHomeBusca i {
  color: #7f888f;
  margin: 0 10px;
}

.clienteHomeBusca input {
  border: 0;
  color: #2d3439;
  font-size: 12px;
  height: 36px;
  min-width: 0;
  outline: none;
  padding: 0 10px 0 0;
  width: 100%;
}

.clienteHomeOrdenacao {
  align-items: center;
  background: #ffffff;
  border: 1px solid #cfd5d9;
  display: flex;
  height: 38px;
  margin: 0;
  padding-left: 10px;
}

.clienteHomeOrdenacao > i {
  color: #7b858b;
  font-size: 12px;
  margin-right: 6px;
}

.clienteHomeOrdenacao select {
  background: transparent;
  border: 0;
  color: #354047;
  cursor: pointer;
  font-size: 11px;
  height: 36px;
  outline: none;
  padding: 0 22px 0 0;
}

.clienteHomeAtualizar {
  align-items: center;
  background: #ffffff;
  border: 1px solid #cfd5d9;
  color: #566169;
  cursor: pointer;
  display: inline-flex;
  height: 38px;
  justify-content: center;
  width: 38px;
}

.clienteHomeAtualizar:hover {
  background: #f2f5f4;
  color: #24734e;
}

.clienteHomeAtualizar:disabled {
  cursor: wait;
  opacity: 0.65;
}

.girando {
  animation: clienteGirar 0.9s linear infinite;
}

@keyframes clienteGirar {
  to {
    transform: rotate(360deg);
  }
}

.clienteHomeAbas {
  border-bottom: 1px solid #ced5d9;
  display: flex;
  gap: 2px;
  margin-top: 14px;
  overflow-x: auto;
  scrollbar-width: thin;
}

.clienteHomeAbas button {
  align-items: center;
  background: transparent;
  border: 0;
  border-bottom: 3px solid transparent;
  color: #69747b;
  cursor: pointer;
  display: inline-flex;
  flex: 0 0 auto;
  font-size: 11px;
  font-weight: 600;
  gap: 7px;
  height: 44px;
  padding: 0 13px;
}

.clienteHomeAbas button:hover {
  background: #f1f4f3;
  color: #273036;
}

.clienteHomeAbas button.ativo {
  border-bottom-color: #2f9967;
  color: #26302b;
}

.clienteCompeticoesAbrir {
  display: none;
}

.clienteCompeticoesReabrir {
  display: none;
}

.clienteHomeAtalhos {
  display: flex;
  gap: 7px;
  justify-content: flex-end;
  margin-top: 12px;
}

.clienteHomeAtalhos .multiEventoButton {
  width: auto;
}

.clienteHomeConteudo {
  display: grid;
  gap: 16px;
  grid-template-columns: minmax(0, 1fr) 290px;
  padding-top: 16px;
}

.clienteHomeLista {
  min-width: 0;
}

.clienteCompeticao {
  background: #ffffff;
  border: 1px solid #dce1e4;
  border-radius: 4px;
  margin-bottom: 12px;
  overflow: hidden;
}

.clienteCompeticao > header {
  align-items: center;
  background: #f4f6f7;
  border-bottom: 1px solid #dce1e4;
  display: flex;
  gap: 9px;
  min-height: 42px;
  padding: 7px 13px;
}

.clienteCompeticao > header img {
  border: 1px solid #cbd1d4;
  height: 13px;
  object-fit: cover;
  width: 19px;
}

.clienteCompeticao > header > i {
  color: #657078;
  font-size: 14px;
  text-align: center;
  width: 19px;
}

.clienteCompeticao > header strong,
.clienteCompeticao > header span {
  display: block;
}

.clienteCompeticao > header strong {
  font-size: 11px;
}

.clienteCompeticao > header span {
  color: #80888e;
  font-size: 8px;
  margin-top: 1px;
}

.clienteEvento {
  align-items: center;
  border-bottom: 1px solid #edf0f2;
  display: grid;
  gap: 10px;
  grid-template-columns: 72px minmax(0, 1fr) 34px 30px 30px;
  min-height: 58px;
  padding: 6px 12px;
  position: relative;
}

.clienteEvento:last-child {
  border-bottom: 0;
}

.clienteEventoAoVivo::before {
  background: #35a66f;
  bottom: 0;
  content: "";
  left: 0;
  position: absolute;
  top: 0;
  width: 3px;
}

.clienteEvento time strong,
.clienteEvento time span,
.clienteEvento time small {
  display: block;
}

.clienteEvento time strong {
  font-size: 14px;
}

.clienteEvento time span {
  color: #27895b;
  font-size: 8px;
  font-weight: 700;
  margin-top: 2px;
}

.clienteEvento time small {
  color: #7b848a;
  font-size: 8px;
  margin-top: 2px;
}

.clienteEventoNome {
  background: transparent;
  border: 0;
  color: #2e363b;
  cursor: pointer;
  font-size: 12px;
  font-weight: 600;
  min-width: 0;
  overflow: hidden;
  padding: 8px 0;
  text-align: left;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.clienteEventoNome > span,
.clienteEventoNome > small {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.clienteEventoNome > small {
  color: #818a90;
  font-size: 8px;
  font-weight: 400;
  margin-top: 3px;
}

.clienteEventoNome:disabled {
  cursor: default;
}

.clienteEventoFavorito {
  align-items: center;
  background: transparent;
  border: 0;
  color: #899198;
  cursor: pointer;
  display: inline-flex;
  height: 32px;
  justify-content: center;
  width: 32px;
}

.clienteEventoFavorito.ativo {
  color: #d29b24;
}

.clienteEventoAssistir {
  align-items: center;
  background: #283137;
  border: 1px solid #283137;
  color: #ffffff;
  cursor: pointer;
  display: inline-flex;
  font-size: 10px;
  font-weight: 600;
  height: 30px;
  justify-content: center;
  padding: 0;
  width: 30px;
}

.clienteEventoAssistirGrafico:hover:not(:disabled) {
  background: #247d54;
  border-color: #247d54;
}

.clienteEventoAssistirLimpo {
  background: #ffffff;
  border-color: #69757d;
  color: #3e494f;
}

.clienteEventoAssistirLimpo:hover:not(:disabled) {
  background: #3e494f;
  border-color: #3e494f;
  color: #ffffff;
}

.clienteEventoAssistir:disabled {
  background: #f1f3f4;
  border-color: #d9dee1;
  color: #9ba2a7;
  cursor: default;
}

.clienteHomeLateral {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.clienteCompeticoesDialog {
  min-width: 0;
}

.clienteLateralBloco {
  background: #ffffff;
  border: 1px solid #dce1e4;
  border-radius: 4px;
}

.clienteLateralBloco > header {
  align-items: center;
  border-bottom: 1px solid #e4e7e9;
  display: flex;
  justify-content: space-between;
  min-height: 42px;
  padding: 8px 12px;
}

.clienteLateralBloco > header > span {
  font-size: 10px;
  font-weight: 700;
}

.clienteLateralBloco > header > strong {
  background: #e6f4ed;
  color: #287c55;
  font-size: 8px;
  padding: 3px 7px;
  text-transform: uppercase;
}

.clienteLateralBloco > header > strong.inativo {
  background: #f5eaea;
  color: #a64f4f;
}

.clientePlanoDetalhe {
  align-items: flex-start;
  display: flex;
  gap: 11px;
  padding: 14px 12px;
}

.clientePlanoDetalhe > i {
  color: #318c61;
  font-size: 20px;
}

.clientePlanoDetalhe strong,
.clientePlanoDetalhe span {
  display: block;
}

.clientePlanoDetalhe strong {
  font-size: 11px;
}

.clientePlanoDetalhe span {
  color: #7c858b;
  font-size: 9px;
  line-height: 1.45;
  margin-top: 3px;
}

.clienteContaLink {
  align-items: center;
  border-top: 1px solid #e4e7e9;
  color: #2c7753;
  display: flex;
  font-size: 10px;
  justify-content: space-between;
  padding: 10px 12px;
  text-decoration: none;
}

.clienteContaLink:hover {
  background: #f4f7f5;
  color: #215c40;
  text-decoration: none;
}

.clienteFiltroCompeticoes > header > div {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.clienteFiltroCompeticoes > header > div > span {
  color: #30383d;
  font-size: 10px;
  font-weight: 700;
}

.clienteFiltroCompeticoes > header > div > small {
  color: #7b858b;
  font-size: 8px;
  margin-top: 2px;
}

.clienteFiltroCompeticoes > header > button {
  background: transparent;
  border: 0;
  color: #2c7753;
  cursor: pointer;
  font-size: 9px;
  font-weight: 600;
  padding: 5px 2px 5px 8px;
}

.clienteFiltroCompeticoes > header > button:hover:not(:disabled) {
  color: #205b3e;
  text-decoration: underline;
}

.clienteFiltroCompeticoes > header > button:disabled {
  color: #a1a8ac;
  cursor: default;
}

.clienteFiltroCompeticoes > header > .clienteCompeticoesFechar {
  display: none;
}

.clienteFiltroCompeticoes > header > .clienteCompeticoesRecolher {
  align-items: center;
  color: #6e7880;
  display: inline-flex;
  font-size: 13px;
  height: 28px;
  justify-content: center;
  padding: 0;
  width: 28px;
}

.clienteCompeticoesOpcoes {
  max-height: 310px;
  overflow-y: auto;
  padding: 0;
  scrollbar-width: thin;
}

.clienteCompeticoesBusca {
  align-items: center;
  background: #ffffff;
  border-bottom: 1px solid #dfe4e6;
  display: flex;
  min-height: 40px;
  padding: 6px 10px;
  position: sticky;
  top: 0;
  z-index: 1;
}

.clienteCompeticoesBusca > i {
  color: #7f898f;
  font-size: 10px;
  margin-right: 7px;
}

.clienteCompeticoesBusca input {
  border: 0;
  color: #30393e;
  font-size: 10px;
  height: 27px;
  min-width: 0;
  outline: none;
  width: 100%;
}

.clienteCompeticoesBusca button {
  align-items: center;
  background: transparent;
  border: 0;
  color: #778188;
  cursor: pointer;
  display: inline-flex;
  height: 26px;
  justify-content: center;
  padding: 0;
  width: 26px;
}

.clienteCompeticoesOpcoes label.clienteCompeticaoOpcao {
  align-items: center;
  border-bottom: 1px solid #edf0f2;
  color: #687279;
  cursor: pointer;
  display: grid;
  gap: 8px;
  grid-template-columns: 14px 20px minmax(0, 1fr) 24px;
  margin: 0;
  min-height: 38px;
  padding: 6px 12px;
}

.clienteCompeticoesOpcoes label.clienteCompeticaoOpcao:last-of-type {
  border-bottom: 0;
}

.clienteCompeticoesOpcoes label.clienteCompeticaoOpcao:hover {
  background: #f7f9f8;
}

.clienteCompeticoesOpcoes label.clienteCompeticaoOpcao.ativo {
  color: #2d3832;
}

.clienteCompeticoesOpcoes label.clienteCompeticaoOpcao input {
  accent-color: #2f9967;
  cursor: pointer;
  height: 13px;
  margin: 0;
  width: 13px;
}

.clienteCompeticoesOpcoes img {
  border: 1px solid #d1d6d9;
  height: 12px;
  object-fit: cover;
  width: 18px;
}

.clienteCompeticoesOpcoes label > span {
  font-size: 9px;
  line-height: 1.35;
  min-width: 0;
  overflow-wrap: anywhere;
}

.clienteCompeticoesOpcoes label > small {
  background: #eef1f2;
  color: #6d777d;
  font-size: 8px;
  padding: 2px 4px;
  text-align: center;
}

.clienteCompeticoesVazio {
  color: #899197;
  font-size: 9px;
  padding: 18px 12px;
  text-align: center;
}

.clienteFiltroCompeticoes > footer {
  align-items: center;
  background: #f7f8f9;
  border-top: 1px solid #e4e7e9;
  color: #778188;
  display: flex;
  font-size: 8px;
  justify-content: space-between;
  padding: 8px 12px;
}

.clienteHomeEstado {
  align-items: center;
  background: #ffffff;
  border: 1px solid #dce1e4;
  color: #7b858c;
  display: flex;
  flex-direction: column;
  gap: 6px;
  justify-content: center;
  min-height: 230px;
  padding: 20px;
  text-align: center;
}

.clienteHomeEstado i {
  font-size: 22px;
}

.clienteHomeEstado strong {
  color: #4d585f;
  font-size: 12px;
}

.clienteHomeEstado span {
  font-size: 10px;
}

@media (min-width: 961px) {
  .clienteHomeConteudoSemCompeticoes {
    grid-template-columns: minmax(0, 1fr);
  }

  .clienteHomeConteudoSemCompeticoes .clienteCompeticoesDialog {
    display: none;
  }

  .clienteCompeticoesReabrir {
    align-items: center;
    background: #ffffff;
    border: 1px solid #ced5d9;
    border-radius: 3px;
    color: #354149;
    display: flex;
    font-size: 10px;
    font-weight: 600;
    gap: 7px;
    height: 34px;
    margin: 0;
    padding: 0 10px;
    width: max-content;
  }

  .clienteCompeticoesReabrir small {
    background: #eef1f3;
    color: #66727a;
    font-size: 9px;
    padding: 2px 5px;
  }
}

@media (max-width: 960px) {
  .clienteHomeConteudo {
    grid-template-columns: 1fr;
  }

  .clienteHomeLateral {
    display: grid;
    grid-template-columns: minmax(0, 1fr);
  }

  .clienteCompeticoesAbrir {
    align-items: center;
    background: #ffffff;
    border: 1px solid #ced5d9;
    border-radius: 3px;
    color: #354149;
    display: flex;
    font-size: 11px;
    font-weight: 600;
    gap: 7px;
    height: 38px;
    justify-content: center;
    margin-top: 0;
    padding: 0 12px;
    width: 100%;
  }

  .clienteHomeAtalhos {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .clienteHomeAtalhos .multiEventoButton {
    height: 38px;
    width: 100%;
  }

  .clienteCompeticoesAbrir small {
    background: #eef1f3;
    color: #66727a;
    font-size: 9px;
    padding: 2px 5px;
  }

  .clienteCompeticoesDialog {
    align-items: center;
    background: rgba(18, 22, 25, 0.68);
    bottom: 0;
    display: none;
    justify-content: center;
    left: 0;
    padding: 12px;
    position: fixed;
    right: 0;
    top: 0;
    z-index: 1080;
  }

  .clienteCompeticoesDialog.ativo {
    display: flex;
  }

  .clienteCompeticoesDialog .clienteFiltroCompeticoes {
    display: flex;
    flex-direction: column;
    max-height: min(680px, calc(100vh - 24px));
    width: min(430px, 100%);
  }

  .clienteCompeticoesDialog .clienteCompeticoesOpcoes {
    flex: 1;
    max-height: none;
  }

  .clienteFiltroCompeticoes > header > .clienteCompeticoesFechar {
    align-items: center;
    color: #6e7880;
    display: inline-flex;
    font-size: 14px;
    height: 28px;
    justify-content: center;
    padding: 0;
    width: 28px;
  }

  .clienteFiltroCompeticoes > header > .clienteCompeticoesRecolher {
    display: none;
  }
}

@media (max-width: 767px) {
  .clienteHome {
    padding: 18px 10px 36px;
  }

  .clienteHomeCabecalho {
    align-items: stretch;
    flex-direction: column;
    gap: 14px;
  }

  .clienteHomeLogo {
    height: 32px;
  }

  .clienteHomeFerramentas {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto 38px;
    width: 100%;
  }

  .clienteHomeBusca {
    flex: 1;
    min-width: 0;
  }

  .clienteHomeOrdenacao {
    padding-left: 8px;
  }

  .clienteEvento {
    gap: 7px;
    grid-template-columns: 56px minmax(0, 1fr) 32px 30px 30px;
    padding-left: 9px;
    padding-right: 8px;
  }

  .clienteHomeLateral {
    grid-template-columns: 1fr;
  }
}
</style>
